import React, {useEffect, useState} from 'react';
import {Col, Row} from "antd";
import {Button, Card, FormGroup} from "components/ui";
import {FormTreeSelect} from "components/ui/form";
import {translate} from "utils/helpers";
import {BiReset, FiFilter} from "react-icons/all";
import {useTranslateContext} from "context/TranslateContext";
import {useFetchTranslateKeyList} from "hooks/useFetch";

function TranslateFilter(props) {

    const {translateKey, handleQuery} = useTranslateContext();
    const initialFilter = {
        key: ''
    }
    const [filter, setFilter] = useState(initialFilter);
    const [isFilter, setIsFilter] = useState(false);
    const [translateKeys, fetchTranslateKeys] = useFetchTranslateKeyList()

    const handleFilter = () => {
        const customQuery = {};
        if (filter.key) customQuery.key = filter.key;
        handleQuery(customQuery);
        setIsFilter(true);
    }

    const handleReset = () => {
        setFilter(initialFilter);
        handleQuery(false);
        setIsFilter(false);
    }

    useEffect(() => {
        fetchTranslateKeys();
    }, [])

    return (
        <Card className="mb-5">
            <div className="filter-box">
                <div className="flex-1">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} lg={24}>
                            <FormGroup
                                label={translate(translateKey + '.Label.TranslateKey')}
                            >
                                <FormTreeSelect
                                    options={[
                                        {key: '', name: translate('enum.Select')},
                                        ...translateKeys.filter(i => i.id !== '')
                                    ]}
                                    fieldNames={{label: 'name', value: 'key'}}
                                    value={filter.key}
                                    onChange={e => setFilter(f => ({...f, key: e}))}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
                <div className="filter-box-buttons lg:pt-[25px]">
                    <Button
                        disabled={!Object.keys(filter).filter(i => filter[i]?.toString()?.trim()).length}
                        onClick={() => handleFilter()}
                        className="filter-box-button"
                        icon={<FiFilter/>}
                    >
                        {translate( 'button.Filter')}
                    </Button>

                    {isFilter > 0 && (
                        <Button
                            onClick={() => handleReset()}
                            className="filter-box-button"
                            property={'red'}
                            icon={<BiReset/>}
                        >
                            {translate( 'button.Reset')}
                        </Button>
                    )}
                </div>
            </div>
        </Card>
    );
}

export default TranslateFilter;
